__turbopack_context__.v({
  "container": "dialInputQldDS-module-scss-module__clB-ha__container",
  "dial-container": "dialInputQldDS-module-scss-module__clB-ha__dial-container",
  "digit": "dialInputQldDS-module-scss-module__clB-ha__digit",
  "digit--decimal": "dialInputQldDS-module-scss-module__clB-ha__digit--decimal",
  "error-msg": "dialInputQldDS-module-scss-module__clB-ha__error-msg",
  "errorContainer": "dialInputQldDS-module-scss-module__clB-ha__errorContainer",
  "errorContent": "dialInputQldDS-module-scss-module__clB-ha__errorContent",
  "errorIcon": "dialInputQldDS-module-scss-module__clB-ha__errorIcon",
  "hint": "dialInputQldDS-module-scss-module__clB-ha__hint",
  "textContainer": "dialInputQldDS-module-scss-module__clB-ha__textContainer",
  "variable-dial-input": "dialInputQldDS-module-scss-module__clB-ha__variable-dial-input",
});
